// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"AxAjDkb0CrNv2VSSq4U2m","cancelBtn":"_3g-njPENeFBo4sE1410g2K","saveBtn":"_3-aHe5SvGHmDe4TP2_YERO"};